// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__FWjb+","section-1":"Federal_section-1__JZc1Y","content":"Federal_content__iLC93","section-2":"Federal_section-2__+WkRr"};